import { render, staticRenderFns } from "./ThumbnailSlotSmall.vue?vue&type=template&id=4edc898e"
import script from "./ThumbnailSlotSmall.vue?vue&type=script&lang=js"
export * from "./ThumbnailSlotSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports